export default __webpack_public_path__ + "static/media/bg-pattern-home-4-about-3.aacd4e03.svg";